module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/specials-7cf05702ce5b20a106c24b247ed0713c.jpg";